import React from "react";
import { ToastContainer } from 'react-toastify';

// // import 'styles/globals.css'
import "../src/styles/globals.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
//import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import 'react-toastify/dist/ReactToastify.css';
import "../node_modules/react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import bootstrap from 'bootstrap/dist/css/bootstrap.min.css';


import { lightTheme, darkTheme } from "../src/styles/darkmode/theme";
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from "../src/styles/darkmode/global";
import { AuthContextProvider } from "../src/context/auth";
import { ThemeContextProvider, useThemeContext } from "../src/context/theme";

import es from 'date-fns/locale/es';
import { registerLocale } from  "react-datepicker";
import { initMercadoPago } from '@mercadopago/sdk-react';
import { useEffect } from 'react';

import "./App.css";
import router from "./components/Router";
import { RouterProvider } from "react-router-dom";

//Router para navegar en la App, agregar las rutas necesarias con sus respectivos componentes
//Para manejar las Protected Routes, necesitamos manejar una lógica con tokens de sesion, por esto utilizamos el context
//En caso de no necesitar Protected Routes, no es necesario utilizarlo
registerLocale('es', es);

function AppContent() {
  const { theme } = useThemeContext();

  useEffect(() => {
    if (window.__CONFIG__.mercadoPagoPublicKey) {
      initMercadoPago(window.__CONFIG__.mercadoPagoPublicKey, {
        locale: 'es-AR'
      });
      console.log('MercadoPago SDK inicializado');
    } else {
      console.error('MercadoPago PUBLIC_KEY no encontrada en variables de entorno');
    }
  }, []);

  // Asegurar que el tema se actualice correctamente
  const currentTheme = theme === 'light' ? lightTheme : darkTheme;

  return (
    <>
      <ToastContainer />
      <ThemeProvider theme={currentTheme} key={theme}>
        <GlobalStyles />
        <RouterProvider router={router} />
      </ThemeProvider>
    </>
  );
}

function App() {
  return (
    <AuthContextProvider>
      <ThemeContextProvider>
        <AppContent />
      </ThemeContextProvider>
    </AuthContextProvider>
  );
}

export default App;
